<template>
  <div class="d-flex align-center nav">
    <img class="navImg" src="@/assets/healthpass.png" alt @click="dashboard" />
    <v-spacer></v-spacer>

    <div class="d-flex align-center">
      <div class="d-flex ml-5">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <p class="mb-0 mr-5" v-on="on">
              {{$i18n.locale == 'en' ? 'English' : 'Ελληνικά'}}
              <v-icon>mdi-chevron-down</v-icon>
            </p>
          </template>
          <v-list dense>
            <v-list-item class="body-2" @click="$i18n.locale = 'en'">English</v-list-item>
            <v-list-item class="body-2" @click="$i18n.locale = 'el'">Ελληνικά</v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <p class="mb-0" v-on="on">
              {{$store.getters.role}}
              <v-icon>mdi-chevron-down</v-icon>
            </p>
          </template>
          <v-list>
            <v-list-item @click="$store.dispatch('logout')">Logout</v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    dashboard() {
      if (this.$store.getters.role == "front") {
        this.$router.push("/frontDesk/dashboard");
      } else if (this.$store.getters.role == "company") {
        this.$router.push("/company/dashboard");
      } else if (this.$store.getters.role == "self") {
        this.$router.push("/selfService/dashboard");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav {
  height: 64px;
  background-color: white;
  border-bottom: 1px solid rgb(239, 239, 239);
}

.navImg {
  margin-left: 5px;
  height: 50px;
  cursor: pointer;
}
</style>